export const baseUrl = 'https://api.hulluware.com'
export const mainSiteBaseUrl = 'https://hulluware.com'
// export const mainSiteBaseUrl = 'http://localhost:3001'
// export const baseUrl = 'http://localhost:4001'
export const TOKEN_KEY = 'hwtoken'

export const path = {
    newStudents: '/api/administrator/students',
    signin: '/api/login?type=admin',
    myAccount: '/api/common/my-account',
    fetchCategories: '/api/common/categories',
    fetchSubCategories: '/api/administrator/sub-categories',
    uploadFile: '/api/administrator/upload-file',
    addCategory: '/api/administrator/add-category',
    addSubCategory: '/api/administrator/add-sub-category',
    getInstructors: '/api/administrator/instructors',
    createInstructor: '/api/administrator/add-instructor',
    addCourse: '/api/instructor/add-course',
    course: '/api/instructor/course',
    readyCourse: '/api/instructor/ready-course',
    getCourses: '/api/instructor/my-courses',
    applySeller: '/api/instructor/apply-seller',
    
    getCourse: '/api/instructor/course',
    getSections: '/api/instructor/sections',
    section: '/api/instructor/section',
    subSection: '/api/instructor/sub-section',
    editSubSectionName: '/api/instructor/edit-subsection-name',
    addSection: '/api/instructor/add-section',
    addSubSection: '/api/instructor/add-sub-section',
    uploadStreamFile: '/api/instructor/upload-stream-file',
    getVideoStream: '/api/instructor/get-video-stream',
    uploadSectionMaterial: '/api/instructor/upload-material',
    getSectionMaterials: '/api/instructor/get-materials',
    material: '/api/instructor/material',
    enrollments: '/api/instructor/enrollments',
    ratings: '/api/instructor/ratings',
    withdrawal: '/api/instructor/withdrawal',
    editSectionOrder: '/api/instructor/edit-section-order',
    editSubSectionOrder: '/api/instructor/edit-subsection-order',
}

export const k = 'kTjNagFc1lXwCFdQQWq7aySUxBPO6rqTFLvGBPa4smU=';
export const i = 'G/I+23afErLNC41YVfoT5A==';